import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface TeamState {
  teamId: string;
  setTeamId: (teamId: string) => void;
}

const useTeamStore = create<TeamState>()(
  persist(
    (set, get) => ({
      teamId: '',
      setTeamId: (teamId) => set({ teamId: teamId })
    }),
    {
      name: 'team-storage'
    }
  )
);

export default useTeamStore;
